import React from 'react';
import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountData } from '../../api';
import { useAuth } from '../../session/InternalAuthProvider';
import { FilterMenu } from '../../common/filter/FilterMenu';
import { WorkshopsFilterSection } from '../../common/filter/WorkshopsFilterSection';
import { CheckboxGroupSection } from '../../common/filter/CheckboxGroupSection';
import {
  ALL_PAYMENT_STATUSES,
  ALL_VOUCHER_STATUSES,
  ALL_VOUCHER_TYPES,
  useVouchersFilter,
} from './VouchersFilterContext';
import { useVouchersFilterSummary } from './useVouchersFilterSummary';

export const VouchersFilter = () => {
  const { t } = useTranslation();
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const summary = useVouchersFilterSummary();
  const {
    statuses,
    setStatuses,
    paymentStatuses,
    setPaymentStatuses,
    orderPageIds,
    setOrderPageIds,
    types,
    setTypes,
    isFilterActive,
    resetFilter,
  } = useVouchersFilter();

  return (
    <FilterMenu
      name="Vouchers"
      isActive={isFilterActive}
      summaryLabel={summary.primary}
      secondaryLabel={summary.secondary}
      onReset={resetFilter}>
      <List disablePadding>
        <CheckboxGroupSection
          title={t('vouchers.filter.status')}
          items={ALL_VOUCHER_STATUSES}
          itemLabel={(status) => t(`vouchers.voucherstatus.${status}`)}
          selected={statuses}
          onChange={setStatuses}
        />

        <CheckboxGroupSection
          title={t('vouchers.type')}
          items={ALL_VOUCHER_TYPES}
          itemLabel={(type) => t(`vouchers.types.${type}`)}
          selected={types}
          onChange={setTypes}
        />

        <WorkshopsFilterSection account={account} selectedIds={orderPageIds} onChange={setOrderPageIds} />

        <CheckboxGroupSection
          title={t('vouchers.filter.paymentStatus')}
          items={ALL_PAYMENT_STATUSES}
          itemLabel={(status) => t(`vouchers.payment_status.${status}`)}
          selected={paymentStatuses}
          onChange={setPaymentStatuses}
          withDivider={false}
        />
      </List>
    </FilterMenu>
  );
};
